import * as dwelling from "./index";
import DwellingContainer from "../containers/DwellingContainer";
import DwellingEstimateContainer from "../containers/DwellingEstimateContainer";
import DwellingFormContainer from "../containers/DwellingFormContainer";
import DwellingFormDiagnosticContainer from "../containers/DwellingFormDiagnosticContainer";
import DwellingsContainer from "../containers/DwellingsContainer";
import RecordContainer from "../containers/RecordContainer";
import SearchContainer from "../containers/SearchContainer";

export const DwellingRoutes = [
  {
    key: "new-dwelling",
    exact: true,
    path: dwelling.NEW_DWELLING,
    component: DwellingFormContainer,
  },
  {
    key: "dwellings",
    exact: true,
    path: dwelling.DWELLINGS,
    component: DwellingsContainer,
  },
  {
    key: "dwelling-details",
    exact: true,
    path: dwelling.DWELLING_DETAILS,
    component: DwellingContainer,
  },
  {
    key: "dwelling-details-estimate",
    exact: true,
    path: dwelling.DWELLING_DETAILS_ESTIMATE,
    component: DwellingEstimateContainer,
  },
  {
    key: "records",
    exact: true,
    path: dwelling.RECORDS,
    component: RecordContainer,
  },
  {
    key: "search",
    exact: true,
    path: dwelling.SEARCH,
    component: SearchContainer,
  },
  {
    key: "update-dwelling",
    exact: true,
    path: dwelling.UPDATE_DWELLING,
    component: DwellingFormContainer,
  },
  {
    key: "update-dwelling-diagnostic",
    exact: true,
    path: dwelling.UPDATE_DWELLING_DIAGNOSTIC,
    component: DwellingFormDiagnosticContainer,
  },
];
